import React from 'react'
import { Typography } from '@material-ui/core'

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16
}

const itemStyle = {
  padding: '5px 0',
  fontSize: 13,
  color: '#555',
  borderBottom: '1px solid #f0f0f0',
  display: 'flex',
  gap: 8
}

const formatRelativeDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  if (diffDays === 1) return 'Yesterday'
  if (diffDays < 7) return `${diffDays}d ago`
  return date.toLocaleDateString()
}

const typeIcons = {
  quote_imported: '\u2713',
  quote_uploaded: '\u2191',
  items_modified: '\u270E'
}

const RecentActivity = ({ activity }) => {
  return (
    <div style={cardStyle}>
      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
        Recent Activity
      </Typography>
      {!activity || activity.length === 0 ? (
        <Typography variant="body2" color="textSecondary">No activity yet.</Typography>
      ) : (
        activity.map((item, idx) => (
          <div key={idx} style={{ ...itemStyle, ...(idx === activity.length - 1 ? { borderBottom: 'none' } : {}) }}>
            <span style={{ flexShrink: 0 }}>{typeIcons[item.type] || '\u2022'}</span>
            <div>
              <div>{item.description}</div>
              <div style={{ fontSize: 11, color: '#999' }}>{formatRelativeDate(item.date)}</div>
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default RecentActivity
